import "../assets/index-e7eadba7.css";
import { N as i } from "../chunks/index-cea13a24.mjs";
import o from "./NcActions.mjs";
import l from "./NcActionButton.mjs";
import { n as u } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const c = {
  name: "NcDashboardWidgetItem",
  components: {
    NcAvatar: i,
    NcActions: o,
    NcActionButton: l
  },
  props: {
    /**
     * The item id (optional)
     */
    id: {
      type: [String, Number],
      default: void 0
    },
    /**
     * The item element is a link to this URL (optional)
     */
    targetUrl: {
      type: String,
      default: void 0
    },
    /**
     * Where to get the avatar image. (optional) Used if avatarUsername is not defined.
     */
    avatarUrl: {
      type: String,
      default: void 0
    },
    /**
     * Name to provide to the Avatar. (optional) Used if avatarUrl is not defined.
     */
    avatarUsername: {
      type: String,
      default: void 0
    },
    /**
     * Is the avatarUsername not a user's name? (optional, false by default)
     */
    avatarIsNoUser: {
      type: Boolean,
      default: !1
    },
    /**
     * Small icon to display on the bottom-right corner of the avatar (optional)
     */
    overlayIconUrl: {
      type: String,
      default: void 0
    },
    /**
     * Item main text (mandatory)
     */
    mainText: {
      type: String,
      required: !0
    },
    /**
     * Item subline text (optional)
     */
    subText: {
      type: String,
      default: ""
    },
    /**
     * An object containing context menu entries that will be displayed for each items (optional)
     */
    itemMenu: {
      type: Object,
      default: () => ({})
    },
    /**
     * Specify whether the 3 dot menu is forced when only one action is present
     */
    forceMenu: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      hovered: !1
    };
  },
  computed: {
    item() {
      return {
        id: this.id,
        targetUrl: this.targetUrl,
        avatarUrl: this.avatarUrl,
        avatarUsername: this.avatarUsername,
        overlayIconUrl: this.overlayIconUrl,
        mainText: this.mainText,
        subText: this.subText
      };
    },
    gotMenu() {
      return Object.keys(this.itemMenu).length !== 0 || !!this.$slots.actions;
    },
    gotOverlayIcon() {
      return this.overlayIconUrl && this.overlayIconUrl !== "";
    }
  },
  methods: {
    onLinkClick(r) {
      r.target.closest(".action-item") && r.preventDefault();
    }
  }
};
var m = function() {
  var t = this, e = t._self._c;
  return e("div", { on: { mouseover: function(a) {
    t.hovered = !0;
  }, mouseleave: function(a) {
    t.hovered = !1;
  } } }, [e(t.targetUrl ? "a" : "div", { tag: "component", class: { "item-list__entry": !0, "item-list__entry--has-actions-menu": t.gotMenu }, attrs: { href: t.targetUrl || void 0, target: t.targetUrl ? "_blank" : void 0 }, on: { click: t.onLinkClick } }, [t._t("avatar", function() {
    return [e("NcAvatar", { staticClass: "item-avatar", attrs: { size: 44, url: t.avatarUrl, user: t.avatarUsername, "is-no-user": t.avatarIsNoUser, "show-user-status": !t.gotOverlayIcon } })];
  }, { avatarUrl: t.avatarUrl, avatarUsername: t.avatarUsername }), t.overlayIconUrl ? e("img", { staticClass: "item-icon", attrs: { alt: "", src: t.overlayIconUrl } }) : t._e(), e("div", { staticClass: "item__details" }, [e("h3", { attrs: { title: t.mainText } }, [t._v(" " + t._s(t.mainText) + " ")]), e("span", { staticClass: "message", attrs: { title: t.subText } }, [t._v(" " + t._s(t.subText) + " ")])]), t.gotMenu ? e("NcActions", { attrs: { "force-menu": t.forceMenu } }, [t._t("actions", function() {
    return t._l(t.itemMenu, function(a, n) {
      return e("NcActionButton", { key: n, attrs: { icon: a.icon, "close-after-click": !0 }, on: { click: function(s) {
        return s.preventDefault(), s.stopPropagation(), t.$emit(n, t.item);
      } } }, [t._v(" " + t._s(a.text) + " ")]);
    });
  })], 2) : t._e()], 2)], 1);
}, d = [], v = /* @__PURE__ */ u(
  c,
  m,
  d,
  !1,
  null,
  "00e861ef",
  null,
  null
);
const y = v.exports;
export {
  y as default
};
